export default function MoneyRenderer(money) {
    return parseFloat(money).toLocaleString('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 4
    });
}